import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { createSanitizedMarkup } from "../../utils/createSanitizedMarkup";
import { DataTable, TableColumnDef } from "../../components/DataTable";
import { TableThumbnail } from "../../components/TableThumbnail";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

import type { NewsItem } from "./types";

type Props = {
  items: NewsItem[];
  onDelete: (id: string) => void;
  onEdit: (newsItem: NewsItem) => void;
  canEdit: boolean;
  canDelete: boolean;
  page: number;
  count: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (perPage: number) => void;
  lang: ContentLanguage;
};

export const ItemsList = ({ items, onDelete, onEdit, canEdit, canDelete, page, count, rowsPerPage, onPageChange, onRowsPerPageChange, lang }: Props) => {
  const columns: TableColumnDef<NewsItem>[] = [
    {
      header: "Bild",
      width: "130px",
      render: (item) => (
        <TableThumbnail src={lang === "de" ? item.mediaUrl_ger?.[0] : item.mediaUrl?.[0]} />
      ),
    },
    {
      header: "Name",
      render: (item) => (lang === "de" ? item.newsName_ger : item.newsName) || "-",
      getValue: (item) => (lang === "de" ? item.newsName_ger : item.newsName) || "-",
    },
    {
      header: "Beschreibung",
      render: (item) => (
        <div
          className="showmore-class"
          style={{ padding: "8px" }}
          dangerouslySetInnerHTML={createSanitizedMarkup({
            html: (lang === "de" ? item?.newsDescription_ger : item?.newsDescription) || "",
          })}
        />
      ),
    },
    {
      header: "Datum",
      render: (item) => moment(item.date).format("DD.MM.YYYY"),
      getValue: (item) => item.date,
    },
    {
      header: "Einstellungen",
      render: (item) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {canEdit && (
            <Tooltip title="Bearbeiten" arrow>
              <IconButton size="small" color="primary" onClick={() => onEdit(item)}>
                <CreateIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip title="Löschen" arrow>
              <IconButton size="small" color="error" onClick={() => onDelete(item._id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  return (
    <DataTable
      rows={items}
      columns={columns}
      page={page}
      count={count}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};
